// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
// for uat 
// "backendApiURL": "https://umnuatapi.plexome.com/"  
    
// for dev
// "backendApiURL": "https://apiumn.zimblecode.com/"
// for prod
// "backendApiURL": "https://umnuatapi.plexome.com/" 

// for ALB https://umnappapi.plexome.com/
};

